import Vue from 'vue'
import Vuex from 'vuex'
import filial from './modules/filial'
import empresa from './modules/empresa'
import colaborador from './modules/colaborador'
import os from './modules/os'
import borracharia from './modules/borracharia'
import osTipo from './modules/os/tipo'
import osItem from './modules/os/item'
import osItemExecucao from './modules/os/items/execucao'
import veiculo from './modules/veiculo'
import frotaItem from './modules/frota/item'
import frotaConjunto from './modules/frota/conjunto'
import inventario from './modules/inventario'
import painel from './modules/painel'
import dashboard from './modules/dashboard'
import { ModalPlugin } from 'bootstrap-vue'
import VueEasyLightbox from 'vue-easy-lightbox'

Vue.component(VueEasyLightbox.name, VueEasyLightbox)
Vue.use(VueEasyLightbox)
Vue.use(Vuex)
Vue.use(ModalPlugin)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    logo: require('../assets/logo.png'),
    logo_escrita: require('../assets/logo_escrita.png'),
    anoAtual: new Date().getFullYear()
  },
  modules: {
    filial,
    empresa,
    colaborador,
    os,
    osTipo,
    osItem,
    osItemExecucao,
    veiculo,
    frotaItem,
    frotaConjunto,
    inventario,
    painel,
    borracharia,
    dashboard
  },
  strict: debug
})
